// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/task/v1/audit.proto" (package "c1.api.task.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Duration } from "../../../../google/protobuf/duration";
import { User } from "../../user/v1/user";
import { ActionInstance } from "../../policy/v1/policy";
import { ApprovalInstance } from "../../policy/v1/policy_steps_approval";
import { TaskAuditCancelledResult } from "../../app/v1/task";
import { TaskAuditErrorResult } from "../../app/v1/task";
import { TaskAuditSuccessResult } from "../../app/v1/task";
import { AccessRequestOutcome } from "./task";
import { RevokeOutcome } from "./task";
import { GrantOutcome } from "./task";
import { CertifyOutcome } from "./task";
import { TaskAction } from "./actions";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { TaskState } from "./task";
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditListRequest
 */
export interface TaskAuditListRequest {
    /**
     * @generated from protobuf field: string task_id = 1;
     */
    taskId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.task.v1.TaskAuditViewRef refs = 4;
     */
    refs: TaskAuditViewRef[];
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditListResponse
 */
export interface TaskAuditListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.task.v1.TaskAuditView list = 1;
     */
    list: TaskAuditView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditView
 */
export interface TaskAuditView {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string user_id = 2;
     */
    userId: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskState current_state = 3;
     */
    currentState: TaskState;
    /**
     * @generated from protobuf field: int32 workflow_step = 4;
     */
    workflowStep: number;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created = 5;
     */
    created?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskAuditMetaData metadata = 6;
     */
    metadata?: TaskAuditMetaData;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskAuditEventType event_type = 7;
     */
    eventType: TaskAuditEventType;
    /**
     * @generated from protobuf field: c1.api.task.v1.Source source = 8;
     */
    source: Source;
    /**
     * @generated from protobuf field: string ticket_id = 9;
     */
    ticketId: string;
    /**
     * @generated from protobuf oneof: typ
     */
    typ: {
        oneofKind: "comment";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditComment comment = 100;
         */
        comment: TaskAuditComment;
    } | {
        oneofKind: "stateChange";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditStateChange state_change = 101;
         */
        stateChange: TaskAuditStateChange;
    } | {
        oneofKind: "approvalInstanceChange";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditApprovalInstanceChange approval_instance_change = 102;
         */
        approvalInstanceChange: TaskAuditApprovalInstanceChange;
    } | {
        oneofKind: "connectorActionsStart";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditStartedConnectorActions connector_actions_start = 103;
         */
        connectorActionsStart: TaskAuditStartedConnectorActions;
    } | {
        oneofKind: "connectorActionsEnd";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditFinishedConnectorActions connector_actions_end = 104;
         */
        connectorActionsEnd: TaskAuditFinishedConnectorActions;
    } | {
        oneofKind: "actionResult";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditConnectorActionResult action_result = 105;
         */
        actionResult: TaskAuditConnectorActionResult;
    } | {
        oneofKind: "taskCreated";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditNewTask task_created = 106;
         */
        taskCreated: TaskAuditNewTask;
    } | {
        oneofKind: "certifyOutcome";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditCertifyOutcome certify_outcome = 107;
         */
        certifyOutcome: TaskAuditCertifyOutcome;
    } | {
        oneofKind: "actionSubmitted";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditActionSubmitted action_submitted = 108;
         */
        actionSubmitted: TaskAuditActionSubmitted;
    } | {
        oneofKind: "grantOutcome";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditGrantOutcome grant_outcome = 109;
         */
        grantOutcome: TaskAuditGrantOutcome;
    } | {
        oneofKind: "revokeOutcome";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditRevokeOutcome revoke_outcome = 110;
         */
        revokeOutcome: TaskAuditRevokeOutcome;
    } | {
        oneofKind: "approvalReassigned";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditPolicyApprovalReassigned approval_reassigned = 111;
         */
        approvalReassigned: TaskAuditPolicyApprovalReassigned;
    } | {
        oneofKind: "taskRestarted";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditRestart task_restarted = 112;
         */
        taskRestarted: TaskAuditRestart;
    } | {
        oneofKind: "accessRequestOutcome";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditAccessRequestOutcome access_request_outcome = 113;
         */
        accessRequestOutcome: TaskAuditAccessRequestOutcome;
    } | {
        oneofKind: "provisionReassigned";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditPolicyProvisionReassigned provision_reassigned = 114;
         */
        provisionReassigned: TaskAuditPolicyProvisionReassigned;
    } | {
        oneofKind: "provisionError";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditPolicyProvisionError provision_error = 115;
         */
        provisionError: TaskAuditPolicyProvisionError;
    } | {
        oneofKind: "approvedAutomatically";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditApprovalHappenedAutomatically approved_automatically = 116;
         */
        approvedAutomatically: TaskAuditApprovalHappenedAutomatically;
    } | {
        oneofKind: "reassignedToDelegate";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditReassignedToDelegate reassigned_to_delegate = 117;
         */
        reassignedToDelegate: TaskAuditReassignedToDelegate;
    } | {
        oneofKind: "hardReset";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditHardReset hard_reset = 118;
         */
        hardReset: TaskAuditHardReset;
    } | {
        oneofKind: "taskEscalated";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditEscalateToEmergencyAccess task_escalated = 119;
         */
        taskEscalated: TaskAuditEscalateToEmergencyAccess;
    } | {
        oneofKind: "conditionalPolicyExecutionResult";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditConditionalPolicyExecutionResult conditional_policy_execution_result = 120;
         */
        conditionalPolicyExecutionResult: TaskAuditConditionalPolicyExecutionResult;
    } | {
        oneofKind: "expressionPolicyStepError";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditExpressionPolicyStepError expression_policy_step_error = 121;
         */
        expressionPolicyStepError: TaskAuditExpressionPolicyStepError;
    } | {
        oneofKind: "approvalAutoAcceptedByPolicy";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditApprovalAutoAcceptedByPolicy approval_auto_accepted_by_policy = 122;
         */
        approvalAutoAcceptedByPolicy: TaskAuditApprovalAutoAcceptedByPolicy;
    } | {
        oneofKind: "approvalAutoRejectedByPolicy";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditApprovalAutoRejectedByPolicy approval_auto_rejected_by_policy = 123;
         */
        approvalAutoRejectedByPolicy: TaskAuditApprovalAutoRejectedByPolicy;
    } | {
        oneofKind: "bulkActionError";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditBulkActionError bulk_action_error = 124;
         */
        bulkActionError: TaskAuditBulkActionError;
    } | {
        oneofKind: "webhookTriggered";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditWebhookTriggered webhook_triggered = 125;
         */
        webhookTriggered: TaskAuditWebhookTriggered;
    } | {
        oneofKind: "webhookAttempt";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditWebhookAttempt webhook_attempt = 126;
         */
        webhookAttempt: TaskAuditWebhookAttempt;
    } | {
        oneofKind: "webhookSuccess";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditWebhookSuccess webhook_success = 127;
         */
        webhookSuccess: TaskAuditWebhookSuccess;
    } | {
        oneofKind: "policyEvaluationStep";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditPolicyEvaluationStep policy_evaluation_step = 128;
         */
        policyEvaluationStep: TaskAuditPolicyEvaluationStep;
    } | {
        oneofKind: "waitStepSuccess";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditWaitStepSuccess wait_step_success = 129;
         */
        waitStepSuccess: TaskAuditWaitStepSuccess;
    } | {
        oneofKind: "waitStepWaiting";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditWaitStepWaiting wait_step_waiting = 130;
         */
        waitStepWaiting: TaskAuditWaitStepWaiting;
    } | {
        oneofKind: "waitStepTimedOut";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditWaitStepTimedOut wait_step_timed_out = 131;
         */
        waitStepTimedOut: TaskAuditWaitStepTimedOut;
    } | {
        oneofKind: "webhookApprovalTriggered";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditWebhookApprovalTriggered webhook_approval_triggered = 132;
         */
        webhookApprovalTriggered: TaskAuditWebhookApprovalTriggered;
    } | {
        oneofKind: "webhookApprovalAttempt";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditWebhookApprovalAttempt webhook_approval_attempt = 133;
         */
        webhookApprovalAttempt: TaskAuditWebhookApprovalAttempt;
    } | {
        oneofKind: "webhookApprovalSuccess";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditWebhookApprovalSuccess webhook_approval_success = 134;
         */
        webhookApprovalSuccess: TaskAuditWebhookApprovalSuccess;
    } | {
        oneofKind: "webhookApprovalBadResponse";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditWebhookApprovalBadResponse webhook_approval_bad_response = 135;
         */
        webhookApprovalBadResponse: TaskAuditWebhookApprovalBadResponse;
    } | {
        oneofKind: "externalTicketTriggered";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditExternalTicketTriggered external_ticket_triggered = 136;
         */
        externalTicketTriggered: TaskAuditExternalTicketTriggered;
    } | {
        oneofKind: "externalTicketCreated";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditExternalTicketCreated external_ticket_created = 137;
         */
        externalTicketCreated: TaskAuditExternalTicketCreated;
    } | {
        oneofKind: "externalTicketError";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditExternalTicketError external_ticket_error = 138;
         */
        externalTicketError: TaskAuditExternalTicketError;
    } | {
        oneofKind: "waitStepAnalysisSuccess";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditWaitForAnalysisStepSuccess wait_step_analysis_success = 139;
         */
        waitStepAnalysisSuccess: TaskAuditWaitForAnalysisStepSuccess;
    } | {
        oneofKind: "waitStepAnalysisWaiting";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditWaitForAnalysisStepWaiting wait_step_analysis_waiting = 140;
         */
        waitStepAnalysisWaiting: TaskAuditWaitForAnalysisStepWaiting;
    } | {
        oneofKind: "waitStepAnalysisTimedOut";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditWaitForAnalysisStepTimedOut wait_step_analysis_timed_out = 141;
         */
        waitStepAnalysisTimedOut: TaskAuditWaitForAnalysisStepTimedOut;
    } | {
        oneofKind: "stepUpApproval";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditStepUpApproval step_up_approval = 142;
         */
        stepUpApproval: TaskAuditStepUpApproval;
    } | {
        oneofKind: "externalTicketProvisionStepResolved";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditExternalTicketProvisionStepResolved external_ticket_provision_step_resolved = 143;
         */
        externalTicketProvisionStepResolved: TaskAuditExternalTicketProvisionStepResolved;
    } | {
        oneofKind: "stepSkipped";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditStepSkipped step_skipped = 144;
         */
        stepSkipped: TaskAuditStepSkipped;
    } | {
        oneofKind: "reassignmentListError";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditReassignmentListError reassignment_list_error = 145;
         */
        reassignmentListError: TaskAuditReassignmentListError;
    } | {
        oneofKind: "slaEscalation";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditSLAEscalation sla_escalation = 146;
         */
        slaEscalation: TaskAuditSLAEscalation;
    } | {
        oneofKind: "policyChanged";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditPolicyChanged policy_changed = 147;
         */
        policyChanged: TaskAuditPolicyChanged;
    } | {
        oneofKind: "formInstanceChange";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditFormInstanceChange form_instance_change = 148;
         */
        formInstanceChange: TaskAuditFormInstanceChange;
    } | {
        oneofKind: "grantDurationUpdated";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditGrantDurationUpdated grant_duration_updated = 149;
         */
        grantDurationUpdated: TaskAuditGrantDurationUpdated;
    } | {
        oneofKind: "waitStepUntilTime";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditWaitStepUntilTime wait_step_until_time = 150;
         */
        waitStepUntilTime: TaskAuditWaitStepUntilTime;
    } | {
        oneofKind: "webhookApprovalFatalError";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditWebhookApprovalFatalError webhook_approval_fatal_error = 151;
         */
        webhookApprovalFatalError: TaskAuditWebhookApprovalFatalError;
    } | {
        oneofKind: "accountLifecycleActionCreated";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditAccountLifecycleActionCreated account_lifecycle_action_created = 152;
         */
        accountLifecycleActionCreated: TaskAuditAccountLifecycleActionCreated;
    } | {
        oneofKind: "accountLifecycleActionFailed";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditAccountLifecycleActionFailed account_lifecycle_action_failed = 153;
         */
        accountLifecycleActionFailed: TaskAuditAccountLifecycleActionFailed;
    } | {
        oneofKind: "provisionCancelled";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditPolicyProvisionCancelled provision_cancelled = 154;
         */
        provisionCancelled: TaskAuditPolicyProvisionCancelled;
    } | {
        oneofKind: "actionInstanceCreated";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditActionInstanceCreated action_instance_created = 155;
         */
        actionInstanceCreated: TaskAuditActionInstanceCreated;
    } | {
        oneofKind: "actionInstanceSucceeded";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditActionInstanceSucceeded action_instance_succeeded = 156;
         */
        actionInstanceSucceeded: TaskAuditActionInstanceSucceeded;
    } | {
        oneofKind: "actionInstanceFailed";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditActionInstanceFailed action_instance_failed = 157;
         */
        actionInstanceFailed: TaskAuditActionInstanceFailed;
    } | {
        oneofKind: "createdReplacementExtensionGrantTask";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditCreatedReplacementExtensionGrantTask created_replacement_extension_grant_task = 158;
         */
        createdReplacementExtensionGrantTask: TaskAuditCreatedReplacementExtensionGrantTask;
    } | {
        oneofKind: "taskCreatedFrom";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditNewTaskCreatedFrom task_created_from = 159;
         */
        taskCreatedFrom: TaskAuditNewTaskCreatedFrom;
    } | {
        oneofKind: "reassignmentFallbackToAdmin";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskAuditReassignmentFallbackToAdmin reassignment_fallback_to_admin = 160;
         */
        reassignmentFallbackToAdmin: TaskAuditReassignmentFallbackToAdmin;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditViewRef
 */
export interface TaskAuditViewRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditStepUpApproval
 */
export interface TaskAuditStepUpApproval {
    /**
     * @generated from protobuf field: string step_up_transaction_id = 1;
     */
    stepUpTransactionId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditReassignmentListError
 */
export interface TaskAuditReassignmentListError {
    /**
     * @generated from protobuf field: string error_message = 1;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditStepSkipped
 */
export interface TaskAuditStepSkipped {
    /**
     * @generated from protobuf field: string skipped_by = 1;
     */
    skippedBy: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditActionSubmitted
 */
export interface TaskAuditActionSubmitted {
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskAction action = 1;
     */
    action?: TaskAction;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditCertifyOutcome
 */
export interface TaskAuditCertifyOutcome {
    /**
     * @generated from protobuf field: c1.api.task.v1.CertifyOutcome outcome = 1;
     */
    outcome: CertifyOutcome;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditGrantOutcome
 */
export interface TaskAuditGrantOutcome {
    /**
     * @generated from protobuf field: c1.api.task.v1.GrantOutcome outcome = 1;
     */
    outcome: GrantOutcome;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditRevokeOutcome
 */
export interface TaskAuditRevokeOutcome {
    /**
     * @generated from protobuf field: c1.api.task.v1.RevokeOutcome outcome = 1;
     */
    outcome: RevokeOutcome;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditAccessRequestOutcome
 */
export interface TaskAuditAccessRequestOutcome {
    /**
     * @generated from protobuf field: c1.api.task.v1.AccessRequestOutcome outcome = 1;
     */
    outcome: AccessRequestOutcome;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditStartedConnectorActions
 */
export interface TaskAuditStartedConnectorActions {
    /**
     * @generated from protobuf field: string policy_step_id = 1;
     */
    policyStepId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditFinishedConnectorActions
 */
export interface TaskAuditFinishedConnectorActions {
    /**
     * @generated from protobuf field: string policy_step_id = 1;
     */
    policyStepId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditNewTask
 */
export interface TaskAuditNewTask {
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditConnectorActionResult
 */
export interface TaskAuditConnectorActionResult {
    /**
     * @generated from protobuf field: string app_id = 4;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 5;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string connector_id = 6;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string connector_action_id = 7;
     */
    connectorActionId: string;
    /**
     * @generated from protobuf oneof: result
     */
    result: {
        oneofKind: "success";
        /**
         * @generated from protobuf field: c1.api.app.v1.TaskAuditSuccessResult success = 1;
         */
        success: TaskAuditSuccessResult;
    } | {
        oneofKind: "error";
        /**
         * @generated from protobuf field: c1.api.app.v1.TaskAuditErrorResult error = 2;
         */
        error: TaskAuditErrorResult;
    } | {
        oneofKind: "cancelled";
        /**
         * @generated from protobuf field: c1.api.app.v1.TaskAuditCancelledResult cancelled = 3;
         */
        cancelled: TaskAuditCancelledResult;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditComment
 */
export interface TaskAuditComment {
    /**
     * @generated from protobuf field: string comment = 1;
     */
    comment: string;
    /**
     * @generated from protobuf field: string updated_by = 2;
     */
    updatedBy: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3;
     */
    updatedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditStateChange
 */
export interface TaskAuditStateChange {
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskState previous_state = 4;
     */
    previousState: TaskState;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditApprovalInstanceChange
 */
export interface TaskAuditApprovalInstanceChange {
    /**
     * @generated from protobuf field: c1.api.policy.v1.ApprovalInstance instance = 4;
     */
    instance?: ApprovalInstance;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditActionInstanceCreated
 */
export interface TaskAuditActionInstanceCreated {
    /**
     * @generated from protobuf field: c1.api.policy.v1.ActionInstance instance = 1;
     */
    instance?: ActionInstance;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditActionInstanceSucceeded
 */
export interface TaskAuditActionInstanceSucceeded {
    /**
     * @generated from protobuf field: c1.api.policy.v1.ActionInstance instance = 1;
     */
    instance?: ActionInstance;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditActionInstanceFailed
 */
export interface TaskAuditActionInstanceFailed {
    /**
     * @generated from protobuf field: c1.api.policy.v1.ActionInstance instance = 1;
     */
    instance?: ActionInstance;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditApprovalAutoAcceptedByPolicy
 */
export interface TaskAuditApprovalAutoAcceptedByPolicy {
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditApprovalAutoRejectedByPolicy
 */
export interface TaskAuditApprovalAutoRejectedByPolicy {
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditApprovalHappenedAutomatically
 */
export interface TaskAuditApprovalHappenedAutomatically {
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditMetaData
 */
export interface TaskAuditMetaData {
    /**
     * @generated from protobuf field: c1.api.user.v1.User user = 2;
     */
    user?: User;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditPolicyApprovalReassigned
 */
export interface TaskAuditPolicyApprovalReassigned {
    /**
     * @generated from protobuf field: string old_policy_step_id = 1;
     */
    oldPolicyStepId: string;
    /**
     * @generated from protobuf field: string new_policy_step_id = 2;
     */
    newPolicyStepId: string;
    /**
     * @generated from protobuf field: repeated string new_users = 3;
     */
    newUsers: string[];
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.User users = 4;
     */
    users: User[];
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditPolicyProvisionReassigned
 */
export interface TaskAuditPolicyProvisionReassigned {
    /**
     * @generated from protobuf field: string old_policy_step_id = 1;
     */
    oldPolicyStepId: string;
    /**
     * @generated from protobuf field: string new_policy_step_id = 2;
     */
    newPolicyStepId: string;
    /**
     * @generated from protobuf field: repeated string new_users = 3;
     */
    newUsers: string[];
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.User users = 4;
     */
    users: User[];
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditPolicyProvisionError
 */
export interface TaskAuditPolicyProvisionError {
    /**
     * @generated from protobuf field: string error = 1;
     */
    error: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditReassignedToDelegate
 */
export interface TaskAuditReassignedToDelegate {
    /**
     * @generated from protobuf field: string original_assignee_user_id = 1;
     */
    originalAssigneeUserId: string;
    /**
     * @generated from protobuf field: string delegated_assignee_user_id = 2;
     */
    delegatedAssigneeUserId: string;
    /**
     * @generated from protobuf field: c1.api.user.v1.User original_assignee_user = 3;
     */
    originalAssigneeUser?: User;
    /**
     * @generated from protobuf field: c1.api.user.v1.User delegated_assignee_user = 4;
     */
    delegatedAssigneeUser?: User;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditRestart
 */
export interface TaskAuditRestart {
    /**
     * @generated from protobuf field: string old_policy_step_id = 1;
     */
    oldPolicyStepId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditHardReset
 */
export interface TaskAuditHardReset {
    /**
     * @generated from protobuf field: string old_policy_step_id = 1;
     */
    oldPolicyStepId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditEscalateToEmergencyAccess
 */
export interface TaskAuditEscalateToEmergencyAccess {
    /**
     * @generated from protobuf field: string old_policy_step_id = 1;
     */
    oldPolicyStepId: string;
    /**
     * @generated from protobuf field: string old_policy_id = 2;
     */
    oldPolicyId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditConditionalPolicyExecutionResult
 */
export interface TaskAuditConditionalPolicyExecutionResult {
    /**
     * @generated from protobuf field: string condition = 1;
     */
    condition: string;
    /**
     * @generated from protobuf field: string policy_key = 2;
     */
    policyKey: string;
    /**
     * @generated from protobuf field: bool condition_matched = 3;
     */
    conditionMatched: boolean;
    /**
     * @generated from protobuf field: bool default_condition = 4;
     */
    defaultCondition: boolean;
    /**
     * @generated from protobuf field: string error = 5;
     */
    error: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditExpressionPolicyStepError
 */
export interface TaskAuditExpressionPolicyStepError {
    /**
     * @generated from protobuf field: string error = 1;
     */
    error: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditBulkActionError
 */
export interface TaskAuditBulkActionError {
    /**
     * @generated from protobuf field: string error = 1;
     */
    error: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditExternalTicketTriggered
 */
export interface TaskAuditExternalTicketTriggered {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string external_ticket_provisioner_config_id = 3;
     */
    externalTicketProvisionerConfigId: string;
    /**
     * @generated from protobuf field: string external_ticket_id = 4;
     */
    externalTicketId: string;
    /**
     * @generated from protobuf field: string external_ticket_provisioner_config_name = 5;
     */
    externalTicketProvisionerConfigName: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditExternalTicketCreated
 */
export interface TaskAuditExternalTicketCreated {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string external_ticket_provisioner_config_id = 3;
     */
    externalTicketProvisionerConfigId: string;
    /**
     * @generated from protobuf field: string external_ticket_id = 4;
     */
    externalTicketId: string;
    /**
     * @generated from protobuf field: string external_ticket_provisioner_config_name = 5;
     */
    externalTicketProvisionerConfigName: string;
    /**
     * @generated from protobuf field: string external_ticket_url = 6;
     */
    externalTicketUrl: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditExternalTicketProvisionStepResolved
 */
export interface TaskAuditExternalTicketProvisionStepResolved {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string external_ticket_provisioner_config_id = 3;
     */
    externalTicketProvisionerConfigId: string;
    /**
     * @generated from protobuf field: string external_ticket_id = 4;
     */
    externalTicketId: string;
    /**
     * @generated from protobuf field: string external_ticket_url = 5;
     */
    externalTicketUrl: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditExternalTicketError
 */
export interface TaskAuditExternalTicketError {
    /**
     * @generated from protobuf field: string error_message = 1;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditWebhookTriggered
 */
export interface TaskAuditWebhookTriggered {
    /**
     * @generated from protobuf field: string webhook_id = 1;
     */
    webhookId: string;
    /**
     * @generated from protobuf field: string webhook_instance_id = 2;
     */
    webhookInstanceId: string;
    /**
     * @generated from protobuf field: string webhook_url = 3;
     */
    webhookUrl: string;
    /**
     * @generated from protobuf field: string webhook_name = 4;
     */
    webhookName: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditWebhookAttempt
 */
export interface TaskAuditWebhookAttempt {
    /**
     * @generated from protobuf field: string webhook_id = 1;
     */
    webhookId: string;
    /**
     * @generated from protobuf field: string webhook_instance_id = 2;
     */
    webhookInstanceId: string;
    /**
     * @generated from protobuf field: string webhook_url = 3;
     */
    webhookUrl: string;
    /**
     * @generated from protobuf field: string webhook_name = 4;
     */
    webhookName: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditWebhookSuccess
 */
export interface TaskAuditWebhookSuccess {
    /**
     * @generated from protobuf field: string webhook_id = 1;
     */
    webhookId: string;
    /**
     * @generated from protobuf field: string webhook_instance_id = 2;
     */
    webhookInstanceId: string;
    /**
     * @generated from protobuf field: string webhook_url = 3;
     */
    webhookUrl: string;
    /**
     * @generated from protobuf field: string webhook_name = 4;
     */
    webhookName: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditWebhookApprovalTriggered
 */
export interface TaskAuditWebhookApprovalTriggered {
    /**
     * @generated from protobuf field: string webhook_id = 1;
     */
    webhookId: string;
    /**
     * @generated from protobuf field: string webhook_instance_id = 2;
     */
    webhookInstanceId: string;
    /**
     * @generated from protobuf field: string webhook_url = 3;
     */
    webhookUrl: string;
    /**
     * @generated from protobuf field: string webhook_name = 4;
     */
    webhookName: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditWebhookApprovalAttempt
 */
export interface TaskAuditWebhookApprovalAttempt {
    /**
     * @generated from protobuf field: string webhook_id = 1;
     */
    webhookId: string;
    /**
     * @generated from protobuf field: string webhook_instance_id = 2;
     */
    webhookInstanceId: string;
    /**
     * @generated from protobuf field: string webhook_url = 3;
     */
    webhookUrl: string;
    /**
     * @generated from protobuf field: string webhook_name = 4;
     */
    webhookName: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditWebhookApprovalSuccess
 */
export interface TaskAuditWebhookApprovalSuccess {
    /**
     * @generated from protobuf field: string webhook_id = 1;
     */
    webhookId: string;
    /**
     * @generated from protobuf field: string webhook_instance_id = 2;
     */
    webhookInstanceId: string;
    /**
     * @generated from protobuf field: string webhook_url = 3;
     */
    webhookUrl: string;
    /**
     * @generated from protobuf field: string webhook_name = 4;
     */
    webhookName: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditWebhookApprovalBadResponse
 */
export interface TaskAuditWebhookApprovalBadResponse {
    /**
     * @generated from protobuf field: string webhook_id = 1;
     */
    webhookId: string;
    /**
     * @generated from protobuf field: string webhook_instance_id = 2;
     */
    webhookInstanceId: string;
    /**
     * @generated from protobuf field: string webhook_url = 3;
     */
    webhookUrl: string;
    /**
     * @generated from protobuf field: string webhook_name = 4;
     */
    webhookName: string;
    /**
     * @generated from protobuf field: string error = 5;
     */
    error: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditWebhookApprovalFatalError
 */
export interface TaskAuditWebhookApprovalFatalError {
    /**
     * @generated from protobuf field: string webhook_id = 1;
     */
    webhookId: string;
    /**
     * @generated from protobuf field: string webhook_instance_id = 2;
     */
    webhookInstanceId: string;
    /**
     * @generated from protobuf field: string webhook_url = 3;
     */
    webhookUrl: string;
    /**
     * @generated from protobuf field: string webhook_name = 4;
     */
    webhookName: string;
    /**
     * @generated from protobuf field: string error = 5;
     */
    error: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditPolicyEvaluationStep
 */
export interface TaskAuditPolicyEvaluationStep {
    /**
     * @generated from protobuf field: string step_comment = 1;
     */
    stepComment: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditWaitStepSuccess
 */
export interface TaskAuditWaitStepSuccess {
    /**
     * @generated from protobuf field: string step_id = 1;
     */
    stepId: string;
    /**
     * @generated from protobuf field: string condition = 2;
     */
    condition: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp succeeded_at = 3;
     */
    succeededAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditWaitStepWaiting
 */
export interface TaskAuditWaitStepWaiting {
    /**
     * @generated from protobuf field: string step_id = 1;
     */
    stepId: string;
    /**
     * @generated from protobuf field: string condition = 2;
     */
    condition: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditWaitStepTimedOut
 */
export interface TaskAuditWaitStepTimedOut {
    /**
     * @generated from protobuf field: string step_id = 1;
     */
    stepId: string;
    /**
     * @generated from protobuf field: string condition = 2;
     */
    condition: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp timed_out_at = 3;
     */
    timedOutAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditWaitForAnalysisStepSuccess
 */
export interface TaskAuditWaitForAnalysisStepSuccess {
    /**
     * @generated from protobuf field: string step_id = 1;
     */
    stepId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp succeeded_at = 3;
     */
    succeededAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditWaitForAnalysisStepWaiting
 */
export interface TaskAuditWaitForAnalysisStepWaiting {
    /**
     * @generated from protobuf field: string step_id = 1;
     */
    stepId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditWaitForAnalysisStepTimedOut
 */
export interface TaskAuditWaitForAnalysisStepTimedOut {
    /**
     * @generated from protobuf field: string step_id = 1;
     */
    stepId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp timed_out_at = 3;
     */
    timedOutAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditSLAEscalation
 */
export interface TaskAuditSLAEscalation {
    /**
     * @generated from protobuf field: string message = 1;
     */
    message: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditPolicyChanged
 */
export interface TaskAuditPolicyChanged {
    /**
     * @generated from protobuf field: string old_policy_id = 1;
     */
    oldPolicyId: string;
    /**
     * @generated from protobuf field: string new_policy_id = 2;
     */
    newPolicyId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditFormInstanceChange
 */
export interface TaskAuditFormInstanceChange {
    /**
     * @generated from protobuf field: bool is_valid = 1;
     */
    isValid: boolean;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditGrantDurationUpdated
 */
export interface TaskAuditGrantDurationUpdated {
    /**
     * @generated from protobuf field: google.protobuf.Duration duration = 1;
     */
    duration?: Duration;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditWaitStepUntilTime
 */
export interface TaskAuditWaitStepUntilTime {
    /**
     * @generated from protobuf field: string step_id = 1;
     */
    stepId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp until_time = 2;
     */
    untilTime?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditAccountLifecycleActionCreated
 */
export interface TaskAuditAccountLifecycleActionCreated {
    /**
     * @generated from protobuf field: string baton_action_invocation_id = 1;
     */
    batonActionInvocationId: string;
    /**
     * @generated from protobuf field: string baton_action_name = 2;
     */
    batonActionName: string;
    /**
     * @generated from protobuf field: string baton_connector_id = 3;
     */
    batonConnectorId: string;
    /**
     * @generated from protobuf field: string baton_app_id = 4;
     */
    batonAppId: string;
    /**
     * @generated from protobuf field: string baton_action_display_name = 5;
     */
    batonActionDisplayName: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditAccountLifecycleActionFailed
 */
export interface TaskAuditAccountLifecycleActionFailed {
    /**
     * @generated from protobuf field: string baton_action_invocation_id = 1;
     */
    batonActionInvocationId: string;
    /**
     * @generated from protobuf field: string baton_action_name = 2;
     */
    batonActionName: string;
    /**
     * @generated from protobuf field: string baton_connector_id = 3;
     */
    batonConnectorId: string;
    /**
     * @generated from protobuf field: string baton_app_id = 4;
     */
    batonAppId: string;
    /**
     * @generated from protobuf field: string baton_action_display_name = 5;
     */
    batonActionDisplayName: string;
    /**
     * @generated from protobuf field: string error = 6;
     */
    error: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditPolicyProvisionCancelled
 */
export interface TaskAuditPolicyProvisionCancelled {
    /**
     * @generated from protobuf field: string cancel_reason = 1;
     */
    cancelReason: string;
}
/**
 * TaskAuditCreatedReplacementExtensionGrantTask is used when a replacement extension grant task is created
 * (e.g. when an extension grant task is cancelled due to app user deletion).
 *
 * @generated from protobuf message c1.api.task.v1.TaskAuditCreatedReplacementExtensionGrantTask
 */
export interface TaskAuditCreatedReplacementExtensionGrantTask {
    /**
     * The ID of the newly created replacement task
     *
     * @generated from protobuf field: string new_task_id = 1;
     */
    newTaskId: string;
    /**
     * The numeric ID of the newly created replacement task (for display)
     *
     * @generated from protobuf field: int64 new_task_numeric_id = 2;
     */
    newTaskNumericId: number;
}
/**
 * TaskAuditNewTaskCreatedFrom is used when a task is created from another task
 * (e.g. when a replacement extension grant task is created after the original is cancelled).
 * This is set on the NEW task to indicate its origin.
 *
 * @generated from protobuf message c1.api.task.v1.TaskAuditNewTaskCreatedFrom
 */
export interface TaskAuditNewTaskCreatedFrom {
    /**
     * @generated from protobuf field: string original_task_id = 1;
     */
    originalTaskId: string;
    /**
     * @generated from protobuf field: int64 original_task_numeric_id = 2;
     */
    originalTaskNumericId: number;
}
/**
 * TaskAuditReassignmentFallbackToAdmin is used when no eligible reviewers are found
 * from the policy configuration and the task falls back to system administrators
 * without creating a new policy step. This prevents reassignment loops.
 *
 * @generated from protobuf message c1.api.task.v1.TaskAuditReassignmentFallbackToAdmin
 */
export interface TaskAuditReassignmentFallbackToAdmin {
    /**
     * The IDs of the system administrator users that the task is being assigned to
     *
     * @generated from protobuf field: repeated string admin_user_ids = 1;
     */
    adminUserIds: string[];
    /**
     * The system administrator users (populated for display)
     *
     * @generated from protobuf field: repeated c1.api.user.v1.User admin_users = 2;
     */
    adminUsers: User[];
}
/**
 * @generated from protobuf enum c1.api.task.v1.Source
 */
export enum Source {
    /**
     * @generated from protobuf enum value: SOURCE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: SOURCE_C1 = 1;
     */
    C1 = 1,
    /**
     * @generated from protobuf enum value: SOURCE_JIRA = 2;
     */
    JIRA = 2,
    /**
     * @generated from protobuf enum value: SOURCE_SLACK = 3;
     */
    SLACK = 3,
    /**
     * @generated from protobuf enum value: SOURCE_COPILOT_AGENTS = 4;
     */
    COPILOT_AGENTS = 4
}
/**
 * @generated from protobuf enum c1.api.task.v1.TaskAuditEventType
 */
export enum TaskAuditEventType {
    /**
     * @generated from protobuf enum value: TASK_AUDIT_EVENT_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: TASK_AUDIT_EVENT_TYPE_NEUTRAL = 1;
     */
    NEUTRAL = 1,
    /**
     * @generated from protobuf enum value: TASK_AUDIT_EVENT_TYPE_ERROR = 2;
     */
    ERROR = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditListRequest$Type extends MessageType<TaskAuditListRequest> {
    constructor() {
        super("c1.api.task.v1.TaskAuditListRequest", [
            { no: 1, name: "task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaskAuditViewRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "256" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditListRequest
 */
export const TaskAuditListRequest = new TaskAuditListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditListResponse$Type extends MessageType<TaskAuditListResponse> {
    constructor() {
        super("c1.api.task.v1.TaskAuditListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaskAuditView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditListResponse
 */
export const TaskAuditListResponse = new TaskAuditListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditView$Type extends MessageType<TaskAuditView> {
    constructor() {
        super("c1.api.task.v1.TaskAuditView", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "current_state", kind: "enum", T: () => ["c1.api.task.v1.TaskState", TaskState, "TASK_STATE_"] },
            { no: 4, name: "workflow_step", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "created", kind: "message", T: () => Timestamp },
            { no: 6, name: "metadata", kind: "message", T: () => TaskAuditMetaData },
            { no: 7, name: "event_type", kind: "enum", T: () => ["c1.api.task.v1.TaskAuditEventType", TaskAuditEventType, "TASK_AUDIT_EVENT_TYPE_"] },
            { no: 8, name: "source", kind: "enum", T: () => ["c1.api.task.v1.Source", Source, "SOURCE_"] },
            { no: 9, name: "ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "comment", kind: "message", oneof: "typ", T: () => TaskAuditComment },
            { no: 101, name: "state_change", kind: "message", oneof: "typ", T: () => TaskAuditStateChange },
            { no: 102, name: "approval_instance_change", kind: "message", oneof: "typ", T: () => TaskAuditApprovalInstanceChange },
            { no: 103, name: "connector_actions_start", kind: "message", oneof: "typ", T: () => TaskAuditStartedConnectorActions },
            { no: 104, name: "connector_actions_end", kind: "message", oneof: "typ", T: () => TaskAuditFinishedConnectorActions },
            { no: 105, name: "action_result", kind: "message", oneof: "typ", T: () => TaskAuditConnectorActionResult },
            { no: 106, name: "task_created", kind: "message", oneof: "typ", T: () => TaskAuditNewTask },
            { no: 107, name: "certify_outcome", kind: "message", oneof: "typ", T: () => TaskAuditCertifyOutcome },
            { no: 108, name: "action_submitted", kind: "message", oneof: "typ", T: () => TaskAuditActionSubmitted },
            { no: 109, name: "grant_outcome", kind: "message", oneof: "typ", T: () => TaskAuditGrantOutcome },
            { no: 110, name: "revoke_outcome", kind: "message", oneof: "typ", T: () => TaskAuditRevokeOutcome },
            { no: 111, name: "approval_reassigned", kind: "message", oneof: "typ", T: () => TaskAuditPolicyApprovalReassigned },
            { no: 112, name: "task_restarted", kind: "message", oneof: "typ", T: () => TaskAuditRestart },
            { no: 113, name: "access_request_outcome", kind: "message", oneof: "typ", T: () => TaskAuditAccessRequestOutcome },
            { no: 114, name: "provision_reassigned", kind: "message", oneof: "typ", T: () => TaskAuditPolicyProvisionReassigned },
            { no: 115, name: "provision_error", kind: "message", oneof: "typ", T: () => TaskAuditPolicyProvisionError },
            { no: 116, name: "approved_automatically", kind: "message", oneof: "typ", T: () => TaskAuditApprovalHappenedAutomatically },
            { no: 117, name: "reassigned_to_delegate", kind: "message", oneof: "typ", T: () => TaskAuditReassignedToDelegate },
            { no: 118, name: "hard_reset", kind: "message", oneof: "typ", T: () => TaskAuditHardReset },
            { no: 119, name: "task_escalated", kind: "message", oneof: "typ", T: () => TaskAuditEscalateToEmergencyAccess },
            { no: 120, name: "conditional_policy_execution_result", kind: "message", oneof: "typ", T: () => TaskAuditConditionalPolicyExecutionResult },
            { no: 121, name: "expression_policy_step_error", kind: "message", oneof: "typ", T: () => TaskAuditExpressionPolicyStepError },
            { no: 122, name: "approval_auto_accepted_by_policy", kind: "message", oneof: "typ", T: () => TaskAuditApprovalAutoAcceptedByPolicy },
            { no: 123, name: "approval_auto_rejected_by_policy", kind: "message", oneof: "typ", T: () => TaskAuditApprovalAutoRejectedByPolicy },
            { no: 124, name: "bulk_action_error", kind: "message", oneof: "typ", T: () => TaskAuditBulkActionError },
            { no: 125, name: "webhook_triggered", kind: "message", oneof: "typ", T: () => TaskAuditWebhookTriggered },
            { no: 126, name: "webhook_attempt", kind: "message", oneof: "typ", T: () => TaskAuditWebhookAttempt },
            { no: 127, name: "webhook_success", kind: "message", oneof: "typ", T: () => TaskAuditWebhookSuccess },
            { no: 128, name: "policy_evaluation_step", kind: "message", oneof: "typ", T: () => TaskAuditPolicyEvaluationStep },
            { no: 129, name: "wait_step_success", kind: "message", oneof: "typ", T: () => TaskAuditWaitStepSuccess },
            { no: 130, name: "wait_step_waiting", kind: "message", oneof: "typ", T: () => TaskAuditWaitStepWaiting },
            { no: 131, name: "wait_step_timed_out", kind: "message", oneof: "typ", T: () => TaskAuditWaitStepTimedOut },
            { no: 132, name: "webhook_approval_triggered", kind: "message", oneof: "typ", T: () => TaskAuditWebhookApprovalTriggered },
            { no: 133, name: "webhook_approval_attempt", kind: "message", oneof: "typ", T: () => TaskAuditWebhookApprovalAttempt },
            { no: 134, name: "webhook_approval_success", kind: "message", oneof: "typ", T: () => TaskAuditWebhookApprovalSuccess },
            { no: 135, name: "webhook_approval_bad_response", kind: "message", oneof: "typ", T: () => TaskAuditWebhookApprovalBadResponse },
            { no: 136, name: "external_ticket_triggered", kind: "message", oneof: "typ", T: () => TaskAuditExternalTicketTriggered },
            { no: 137, name: "external_ticket_created", kind: "message", oneof: "typ", T: () => TaskAuditExternalTicketCreated },
            { no: 138, name: "external_ticket_error", kind: "message", oneof: "typ", T: () => TaskAuditExternalTicketError },
            { no: 139, name: "wait_step_analysis_success", kind: "message", oneof: "typ", T: () => TaskAuditWaitForAnalysisStepSuccess },
            { no: 140, name: "wait_step_analysis_waiting", kind: "message", oneof: "typ", T: () => TaskAuditWaitForAnalysisStepWaiting },
            { no: 141, name: "wait_step_analysis_timed_out", kind: "message", oneof: "typ", T: () => TaskAuditWaitForAnalysisStepTimedOut },
            { no: 142, name: "step_up_approval", kind: "message", oneof: "typ", T: () => TaskAuditStepUpApproval },
            { no: 143, name: "external_ticket_provision_step_resolved", kind: "message", oneof: "typ", T: () => TaskAuditExternalTicketProvisionStepResolved },
            { no: 144, name: "step_skipped", kind: "message", oneof: "typ", T: () => TaskAuditStepSkipped },
            { no: 145, name: "reassignment_list_error", kind: "message", oneof: "typ", T: () => TaskAuditReassignmentListError },
            { no: 146, name: "sla_escalation", kind: "message", oneof: "typ", T: () => TaskAuditSLAEscalation },
            { no: 147, name: "policy_changed", kind: "message", oneof: "typ", T: () => TaskAuditPolicyChanged },
            { no: 148, name: "form_instance_change", kind: "message", oneof: "typ", T: () => TaskAuditFormInstanceChange },
            { no: 149, name: "grant_duration_updated", kind: "message", oneof: "typ", T: () => TaskAuditGrantDurationUpdated },
            { no: 150, name: "wait_step_until_time", kind: "message", oneof: "typ", T: () => TaskAuditWaitStepUntilTime },
            { no: 151, name: "webhook_approval_fatal_error", kind: "message", oneof: "typ", T: () => TaskAuditWebhookApprovalFatalError },
            { no: 152, name: "account_lifecycle_action_created", kind: "message", oneof: "typ", T: () => TaskAuditAccountLifecycleActionCreated },
            { no: 153, name: "account_lifecycle_action_failed", kind: "message", oneof: "typ", T: () => TaskAuditAccountLifecycleActionFailed },
            { no: 154, name: "provision_cancelled", kind: "message", oneof: "typ", T: () => TaskAuditPolicyProvisionCancelled },
            { no: 155, name: "action_instance_created", kind: "message", oneof: "typ", T: () => TaskAuditActionInstanceCreated },
            { no: 156, name: "action_instance_succeeded", kind: "message", oneof: "typ", T: () => TaskAuditActionInstanceSucceeded },
            { no: 157, name: "action_instance_failed", kind: "message", oneof: "typ", T: () => TaskAuditActionInstanceFailed },
            { no: 158, name: "created_replacement_extension_grant_task", kind: "message", oneof: "typ", T: () => TaskAuditCreatedReplacementExtensionGrantTask },
            { no: 159, name: "task_created_from", kind: "message", oneof: "typ", T: () => TaskAuditNewTaskCreatedFrom },
            { no: 160, name: "reassignment_fallback_to_admin", kind: "message", oneof: "typ", T: () => TaskAuditReassignmentFallbackToAdmin }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditView
 */
export const TaskAuditView = new TaskAuditView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditViewRef$Type extends MessageType<TaskAuditViewRef> {
    constructor() {
        super("c1.api.task.v1.TaskAuditViewRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditViewRef
 */
export const TaskAuditViewRef = new TaskAuditViewRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditStepUpApproval$Type extends MessageType<TaskAuditStepUpApproval> {
    constructor() {
        super("c1.api.task.v1.TaskAuditStepUpApproval", [
            { no: 1, name: "step_up_transaction_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditStepUpApproval
 */
export const TaskAuditStepUpApproval = new TaskAuditStepUpApproval$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditReassignmentListError$Type extends MessageType<TaskAuditReassignmentListError> {
    constructor() {
        super("c1.api.task.v1.TaskAuditReassignmentListError", [
            { no: 1, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditReassignmentListError
 */
export const TaskAuditReassignmentListError = new TaskAuditReassignmentListError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditStepSkipped$Type extends MessageType<TaskAuditStepSkipped> {
    constructor() {
        super("c1.api.task.v1.TaskAuditStepSkipped", [
            { no: 1, name: "skipped_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditStepSkipped
 */
export const TaskAuditStepSkipped = new TaskAuditStepSkipped$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditActionSubmitted$Type extends MessageType<TaskAuditActionSubmitted> {
    constructor() {
        super("c1.api.task.v1.TaskAuditActionSubmitted", [
            { no: 1, name: "action", kind: "message", T: () => TaskAction }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditActionSubmitted
 */
export const TaskAuditActionSubmitted = new TaskAuditActionSubmitted$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditCertifyOutcome$Type extends MessageType<TaskAuditCertifyOutcome> {
    constructor() {
        super("c1.api.task.v1.TaskAuditCertifyOutcome", [
            { no: 1, name: "outcome", kind: "enum", T: () => ["c1.api.task.v1.CertifyOutcome", CertifyOutcome, "CERTIFY_OUTCOME_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditCertifyOutcome
 */
export const TaskAuditCertifyOutcome = new TaskAuditCertifyOutcome$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditGrantOutcome$Type extends MessageType<TaskAuditGrantOutcome> {
    constructor() {
        super("c1.api.task.v1.TaskAuditGrantOutcome", [
            { no: 1, name: "outcome", kind: "enum", T: () => ["c1.api.task.v1.GrantOutcome", GrantOutcome, "GRANT_OUTCOME_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditGrantOutcome
 */
export const TaskAuditGrantOutcome = new TaskAuditGrantOutcome$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditRevokeOutcome$Type extends MessageType<TaskAuditRevokeOutcome> {
    constructor() {
        super("c1.api.task.v1.TaskAuditRevokeOutcome", [
            { no: 1, name: "outcome", kind: "enum", T: () => ["c1.api.task.v1.RevokeOutcome", RevokeOutcome, "REVOKE_OUTCOME_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditRevokeOutcome
 */
export const TaskAuditRevokeOutcome = new TaskAuditRevokeOutcome$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditAccessRequestOutcome$Type extends MessageType<TaskAuditAccessRequestOutcome> {
    constructor() {
        super("c1.api.task.v1.TaskAuditAccessRequestOutcome", [
            { no: 1, name: "outcome", kind: "enum", T: () => ["c1.api.task.v1.AccessRequestOutcome", AccessRequestOutcome, "ACCESS_REQUEST_OUTCOME_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditAccessRequestOutcome
 */
export const TaskAuditAccessRequestOutcome = new TaskAuditAccessRequestOutcome$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditStartedConnectorActions$Type extends MessageType<TaskAuditStartedConnectorActions> {
    constructor() {
        super("c1.api.task.v1.TaskAuditStartedConnectorActions", [
            { no: 1, name: "policy_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditStartedConnectorActions
 */
export const TaskAuditStartedConnectorActions = new TaskAuditStartedConnectorActions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditFinishedConnectorActions$Type extends MessageType<TaskAuditFinishedConnectorActions> {
    constructor() {
        super("c1.api.task.v1.TaskAuditFinishedConnectorActions", [
            { no: 1, name: "policy_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditFinishedConnectorActions
 */
export const TaskAuditFinishedConnectorActions = new TaskAuditFinishedConnectorActions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditNewTask$Type extends MessageType<TaskAuditNewTask> {
    constructor() {
        super("c1.api.task.v1.TaskAuditNewTask", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditNewTask
 */
export const TaskAuditNewTask = new TaskAuditNewTask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditConnectorActionResult$Type extends MessageType<TaskAuditConnectorActionResult> {
    constructor() {
        super("c1.api.task.v1.TaskAuditConnectorActionResult", [
            { no: 4, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 5, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 6, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 7, name: "connector_action_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 1, name: "success", kind: "message", oneof: "result", T: () => TaskAuditSuccessResult },
            { no: 2, name: "error", kind: "message", oneof: "result", T: () => TaskAuditErrorResult },
            { no: 3, name: "cancelled", kind: "message", oneof: "result", T: () => TaskAuditCancelledResult }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditConnectorActionResult
 */
export const TaskAuditConnectorActionResult = new TaskAuditConnectorActionResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditComment$Type extends MessageType<TaskAuditComment> {
    constructor() {
        super("c1.api.task.v1.TaskAuditComment", [
            { no: 1, name: "comment", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "updated_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditComment
 */
export const TaskAuditComment = new TaskAuditComment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditStateChange$Type extends MessageType<TaskAuditStateChange> {
    constructor() {
        super("c1.api.task.v1.TaskAuditStateChange", [
            { no: 4, name: "previous_state", kind: "enum", T: () => ["c1.api.task.v1.TaskState", TaskState, "TASK_STATE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditStateChange
 */
export const TaskAuditStateChange = new TaskAuditStateChange$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditApprovalInstanceChange$Type extends MessageType<TaskAuditApprovalInstanceChange> {
    constructor() {
        super("c1.api.task.v1.TaskAuditApprovalInstanceChange", [
            { no: 4, name: "instance", kind: "message", T: () => ApprovalInstance }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditApprovalInstanceChange
 */
export const TaskAuditApprovalInstanceChange = new TaskAuditApprovalInstanceChange$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditActionInstanceCreated$Type extends MessageType<TaskAuditActionInstanceCreated> {
    constructor() {
        super("c1.api.task.v1.TaskAuditActionInstanceCreated", [
            { no: 1, name: "instance", kind: "message", T: () => ActionInstance }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditActionInstanceCreated
 */
export const TaskAuditActionInstanceCreated = new TaskAuditActionInstanceCreated$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditActionInstanceSucceeded$Type extends MessageType<TaskAuditActionInstanceSucceeded> {
    constructor() {
        super("c1.api.task.v1.TaskAuditActionInstanceSucceeded", [
            { no: 1, name: "instance", kind: "message", T: () => ActionInstance }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditActionInstanceSucceeded
 */
export const TaskAuditActionInstanceSucceeded = new TaskAuditActionInstanceSucceeded$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditActionInstanceFailed$Type extends MessageType<TaskAuditActionInstanceFailed> {
    constructor() {
        super("c1.api.task.v1.TaskAuditActionInstanceFailed", [
            { no: 1, name: "instance", kind: "message", T: () => ActionInstance }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditActionInstanceFailed
 */
export const TaskAuditActionInstanceFailed = new TaskAuditActionInstanceFailed$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditApprovalAutoAcceptedByPolicy$Type extends MessageType<TaskAuditApprovalAutoAcceptedByPolicy> {
    constructor() {
        super("c1.api.task.v1.TaskAuditApprovalAutoAcceptedByPolicy", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditApprovalAutoAcceptedByPolicy
 */
export const TaskAuditApprovalAutoAcceptedByPolicy = new TaskAuditApprovalAutoAcceptedByPolicy$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditApprovalAutoRejectedByPolicy$Type extends MessageType<TaskAuditApprovalAutoRejectedByPolicy> {
    constructor() {
        super("c1.api.task.v1.TaskAuditApprovalAutoRejectedByPolicy", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditApprovalAutoRejectedByPolicy
 */
export const TaskAuditApprovalAutoRejectedByPolicy = new TaskAuditApprovalAutoRejectedByPolicy$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditApprovalHappenedAutomatically$Type extends MessageType<TaskAuditApprovalHappenedAutomatically> {
    constructor() {
        super("c1.api.task.v1.TaskAuditApprovalHappenedAutomatically", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditApprovalHappenedAutomatically
 */
export const TaskAuditApprovalHappenedAutomatically = new TaskAuditApprovalHappenedAutomatically$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditMetaData$Type extends MessageType<TaskAuditMetaData> {
    constructor() {
        super("c1.api.task.v1.TaskAuditMetaData", [
            { no: 2, name: "user", kind: "message", T: () => User }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditMetaData
 */
export const TaskAuditMetaData = new TaskAuditMetaData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditPolicyApprovalReassigned$Type extends MessageType<TaskAuditPolicyApprovalReassigned> {
    constructor() {
        super("c1.api.task.v1.TaskAuditPolicyApprovalReassigned", [
            { no: 1, name: "old_policy_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "new_policy_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "new_users", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "users", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => User }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditPolicyApprovalReassigned
 */
export const TaskAuditPolicyApprovalReassigned = new TaskAuditPolicyApprovalReassigned$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditPolicyProvisionReassigned$Type extends MessageType<TaskAuditPolicyProvisionReassigned> {
    constructor() {
        super("c1.api.task.v1.TaskAuditPolicyProvisionReassigned", [
            { no: 1, name: "old_policy_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "new_policy_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "new_users", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "users", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => User }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditPolicyProvisionReassigned
 */
export const TaskAuditPolicyProvisionReassigned = new TaskAuditPolicyProvisionReassigned$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditPolicyProvisionError$Type extends MessageType<TaskAuditPolicyProvisionError> {
    constructor() {
        super("c1.api.task.v1.TaskAuditPolicyProvisionError", [
            { no: 1, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditPolicyProvisionError
 */
export const TaskAuditPolicyProvisionError = new TaskAuditPolicyProvisionError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditReassignedToDelegate$Type extends MessageType<TaskAuditReassignedToDelegate> {
    constructor() {
        super("c1.api.task.v1.TaskAuditReassignedToDelegate", [
            { no: 1, name: "original_assignee_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "delegated_assignee_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "original_assignee_user", kind: "message", T: () => User },
            { no: 4, name: "delegated_assignee_user", kind: "message", T: () => User }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditReassignedToDelegate
 */
export const TaskAuditReassignedToDelegate = new TaskAuditReassignedToDelegate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditRestart$Type extends MessageType<TaskAuditRestart> {
    constructor() {
        super("c1.api.task.v1.TaskAuditRestart", [
            { no: 1, name: "old_policy_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditRestart
 */
export const TaskAuditRestart = new TaskAuditRestart$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditHardReset$Type extends MessageType<TaskAuditHardReset> {
    constructor() {
        super("c1.api.task.v1.TaskAuditHardReset", [
            { no: 1, name: "old_policy_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditHardReset
 */
export const TaskAuditHardReset = new TaskAuditHardReset$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditEscalateToEmergencyAccess$Type extends MessageType<TaskAuditEscalateToEmergencyAccess> {
    constructor() {
        super("c1.api.task.v1.TaskAuditEscalateToEmergencyAccess", [
            { no: 1, name: "old_policy_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "old_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditEscalateToEmergencyAccess
 */
export const TaskAuditEscalateToEmergencyAccess = new TaskAuditEscalateToEmergencyAccess$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditConditionalPolicyExecutionResult$Type extends MessageType<TaskAuditConditionalPolicyExecutionResult> {
    constructor() {
        super("c1.api.task.v1.TaskAuditConditionalPolicyExecutionResult", [
            { no: 1, name: "condition", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "policy_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "condition_matched", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "default_condition", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditConditionalPolicyExecutionResult
 */
export const TaskAuditConditionalPolicyExecutionResult = new TaskAuditConditionalPolicyExecutionResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditExpressionPolicyStepError$Type extends MessageType<TaskAuditExpressionPolicyStepError> {
    constructor() {
        super("c1.api.task.v1.TaskAuditExpressionPolicyStepError", [
            { no: 1, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditExpressionPolicyStepError
 */
export const TaskAuditExpressionPolicyStepError = new TaskAuditExpressionPolicyStepError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditBulkActionError$Type extends MessageType<TaskAuditBulkActionError> {
    constructor() {
        super("c1.api.task.v1.TaskAuditBulkActionError", [
            { no: 1, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditBulkActionError
 */
export const TaskAuditBulkActionError = new TaskAuditBulkActionError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditExternalTicketTriggered$Type extends MessageType<TaskAuditExternalTicketTriggered> {
    constructor() {
        super("c1.api.task.v1.TaskAuditExternalTicketTriggered", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "external_ticket_provisioner_config_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "external_ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "external_ticket_provisioner_config_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditExternalTicketTriggered
 */
export const TaskAuditExternalTicketTriggered = new TaskAuditExternalTicketTriggered$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditExternalTicketCreated$Type extends MessageType<TaskAuditExternalTicketCreated> {
    constructor() {
        super("c1.api.task.v1.TaskAuditExternalTicketCreated", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "external_ticket_provisioner_config_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "external_ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "external_ticket_provisioner_config_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "external_ticket_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditExternalTicketCreated
 */
export const TaskAuditExternalTicketCreated = new TaskAuditExternalTicketCreated$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditExternalTicketProvisionStepResolved$Type extends MessageType<TaskAuditExternalTicketProvisionStepResolved> {
    constructor() {
        super("c1.api.task.v1.TaskAuditExternalTicketProvisionStepResolved", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "external_ticket_provisioner_config_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "external_ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "external_ticket_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditExternalTicketProvisionStepResolved
 */
export const TaskAuditExternalTicketProvisionStepResolved = new TaskAuditExternalTicketProvisionStepResolved$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditExternalTicketError$Type extends MessageType<TaskAuditExternalTicketError> {
    constructor() {
        super("c1.api.task.v1.TaskAuditExternalTicketError", [
            { no: 1, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditExternalTicketError
 */
export const TaskAuditExternalTicketError = new TaskAuditExternalTicketError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditWebhookTriggered$Type extends MessageType<TaskAuditWebhookTriggered> {
    constructor() {
        super("c1.api.task.v1.TaskAuditWebhookTriggered", [
            { no: 1, name: "webhook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "webhook_instance_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "webhook_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "webhook_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditWebhookTriggered
 */
export const TaskAuditWebhookTriggered = new TaskAuditWebhookTriggered$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditWebhookAttempt$Type extends MessageType<TaskAuditWebhookAttempt> {
    constructor() {
        super("c1.api.task.v1.TaskAuditWebhookAttempt", [
            { no: 1, name: "webhook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "webhook_instance_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "webhook_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "webhook_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditWebhookAttempt
 */
export const TaskAuditWebhookAttempt = new TaskAuditWebhookAttempt$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditWebhookSuccess$Type extends MessageType<TaskAuditWebhookSuccess> {
    constructor() {
        super("c1.api.task.v1.TaskAuditWebhookSuccess", [
            { no: 1, name: "webhook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "webhook_instance_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "webhook_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "webhook_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditWebhookSuccess
 */
export const TaskAuditWebhookSuccess = new TaskAuditWebhookSuccess$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditWebhookApprovalTriggered$Type extends MessageType<TaskAuditWebhookApprovalTriggered> {
    constructor() {
        super("c1.api.task.v1.TaskAuditWebhookApprovalTriggered", [
            { no: 1, name: "webhook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "webhook_instance_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "webhook_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "webhook_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditWebhookApprovalTriggered
 */
export const TaskAuditWebhookApprovalTriggered = new TaskAuditWebhookApprovalTriggered$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditWebhookApprovalAttempt$Type extends MessageType<TaskAuditWebhookApprovalAttempt> {
    constructor() {
        super("c1.api.task.v1.TaskAuditWebhookApprovalAttempt", [
            { no: 1, name: "webhook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "webhook_instance_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "webhook_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "webhook_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditWebhookApprovalAttempt
 */
export const TaskAuditWebhookApprovalAttempt = new TaskAuditWebhookApprovalAttempt$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditWebhookApprovalSuccess$Type extends MessageType<TaskAuditWebhookApprovalSuccess> {
    constructor() {
        super("c1.api.task.v1.TaskAuditWebhookApprovalSuccess", [
            { no: 1, name: "webhook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "webhook_instance_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "webhook_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "webhook_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditWebhookApprovalSuccess
 */
export const TaskAuditWebhookApprovalSuccess = new TaskAuditWebhookApprovalSuccess$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditWebhookApprovalBadResponse$Type extends MessageType<TaskAuditWebhookApprovalBadResponse> {
    constructor() {
        super("c1.api.task.v1.TaskAuditWebhookApprovalBadResponse", [
            { no: 1, name: "webhook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "webhook_instance_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "webhook_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "webhook_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditWebhookApprovalBadResponse
 */
export const TaskAuditWebhookApprovalBadResponse = new TaskAuditWebhookApprovalBadResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditWebhookApprovalFatalError$Type extends MessageType<TaskAuditWebhookApprovalFatalError> {
    constructor() {
        super("c1.api.task.v1.TaskAuditWebhookApprovalFatalError", [
            { no: 1, name: "webhook_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "webhook_instance_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "webhook_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "webhook_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditWebhookApprovalFatalError
 */
export const TaskAuditWebhookApprovalFatalError = new TaskAuditWebhookApprovalFatalError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditPolicyEvaluationStep$Type extends MessageType<TaskAuditPolicyEvaluationStep> {
    constructor() {
        super("c1.api.task.v1.TaskAuditPolicyEvaluationStep", [
            { no: 1, name: "step_comment", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditPolicyEvaluationStep
 */
export const TaskAuditPolicyEvaluationStep = new TaskAuditPolicyEvaluationStep$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditWaitStepSuccess$Type extends MessageType<TaskAuditWaitStepSuccess> {
    constructor() {
        super("c1.api.task.v1.TaskAuditWaitStepSuccess", [
            { no: 1, name: "step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "condition", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "succeeded_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditWaitStepSuccess
 */
export const TaskAuditWaitStepSuccess = new TaskAuditWaitStepSuccess$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditWaitStepWaiting$Type extends MessageType<TaskAuditWaitStepWaiting> {
    constructor() {
        super("c1.api.task.v1.TaskAuditWaitStepWaiting", [
            { no: 1, name: "step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "condition", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditWaitStepWaiting
 */
export const TaskAuditWaitStepWaiting = new TaskAuditWaitStepWaiting$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditWaitStepTimedOut$Type extends MessageType<TaskAuditWaitStepTimedOut> {
    constructor() {
        super("c1.api.task.v1.TaskAuditWaitStepTimedOut", [
            { no: 1, name: "step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "condition", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "timed_out_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditWaitStepTimedOut
 */
export const TaskAuditWaitStepTimedOut = new TaskAuditWaitStepTimedOut$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditWaitForAnalysisStepSuccess$Type extends MessageType<TaskAuditWaitForAnalysisStepSuccess> {
    constructor() {
        super("c1.api.task.v1.TaskAuditWaitForAnalysisStepSuccess", [
            { no: 1, name: "step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "succeeded_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditWaitForAnalysisStepSuccess
 */
export const TaskAuditWaitForAnalysisStepSuccess = new TaskAuditWaitForAnalysisStepSuccess$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditWaitForAnalysisStepWaiting$Type extends MessageType<TaskAuditWaitForAnalysisStepWaiting> {
    constructor() {
        super("c1.api.task.v1.TaskAuditWaitForAnalysisStepWaiting", [
            { no: 1, name: "step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditWaitForAnalysisStepWaiting
 */
export const TaskAuditWaitForAnalysisStepWaiting = new TaskAuditWaitForAnalysisStepWaiting$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditWaitForAnalysisStepTimedOut$Type extends MessageType<TaskAuditWaitForAnalysisStepTimedOut> {
    constructor() {
        super("c1.api.task.v1.TaskAuditWaitForAnalysisStepTimedOut", [
            { no: 1, name: "step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "timed_out_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditWaitForAnalysisStepTimedOut
 */
export const TaskAuditWaitForAnalysisStepTimedOut = new TaskAuditWaitForAnalysisStepTimedOut$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditSLAEscalation$Type extends MessageType<TaskAuditSLAEscalation> {
    constructor() {
        super("c1.api.task.v1.TaskAuditSLAEscalation", [
            { no: 1, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditSLAEscalation
 */
export const TaskAuditSLAEscalation = new TaskAuditSLAEscalation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditPolicyChanged$Type extends MessageType<TaskAuditPolicyChanged> {
    constructor() {
        super("c1.api.task.v1.TaskAuditPolicyChanged", [
            { no: 1, name: "old_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "new_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditPolicyChanged
 */
export const TaskAuditPolicyChanged = new TaskAuditPolicyChanged$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditFormInstanceChange$Type extends MessageType<TaskAuditFormInstanceChange> {
    constructor() {
        super("c1.api.task.v1.TaskAuditFormInstanceChange", [
            { no: 1, name: "is_valid", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditFormInstanceChange
 */
export const TaskAuditFormInstanceChange = new TaskAuditFormInstanceChange$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditGrantDurationUpdated$Type extends MessageType<TaskAuditGrantDurationUpdated> {
    constructor() {
        super("c1.api.task.v1.TaskAuditGrantDurationUpdated", [
            { no: 1, name: "duration", kind: "message", T: () => Duration }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditGrantDurationUpdated
 */
export const TaskAuditGrantDurationUpdated = new TaskAuditGrantDurationUpdated$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditWaitStepUntilTime$Type extends MessageType<TaskAuditWaitStepUntilTime> {
    constructor() {
        super("c1.api.task.v1.TaskAuditWaitStepUntilTime", [
            { no: 1, name: "step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "until_time", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditWaitStepUntilTime
 */
export const TaskAuditWaitStepUntilTime = new TaskAuditWaitStepUntilTime$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditAccountLifecycleActionCreated$Type extends MessageType<TaskAuditAccountLifecycleActionCreated> {
    constructor() {
        super("c1.api.task.v1.TaskAuditAccountLifecycleActionCreated", [
            { no: 1, name: "baton_action_invocation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "baton_action_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "baton_connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "baton_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "baton_action_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditAccountLifecycleActionCreated
 */
export const TaskAuditAccountLifecycleActionCreated = new TaskAuditAccountLifecycleActionCreated$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditAccountLifecycleActionFailed$Type extends MessageType<TaskAuditAccountLifecycleActionFailed> {
    constructor() {
        super("c1.api.task.v1.TaskAuditAccountLifecycleActionFailed", [
            { no: 1, name: "baton_action_invocation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "baton_action_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "baton_connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "baton_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "baton_action_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditAccountLifecycleActionFailed
 */
export const TaskAuditAccountLifecycleActionFailed = new TaskAuditAccountLifecycleActionFailed$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditPolicyProvisionCancelled$Type extends MessageType<TaskAuditPolicyProvisionCancelled> {
    constructor() {
        super("c1.api.task.v1.TaskAuditPolicyProvisionCancelled", [
            { no: 1, name: "cancel_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditPolicyProvisionCancelled
 */
export const TaskAuditPolicyProvisionCancelled = new TaskAuditPolicyProvisionCancelled$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditCreatedReplacementExtensionGrantTask$Type extends MessageType<TaskAuditCreatedReplacementExtensionGrantTask> {
    constructor() {
        super("c1.api.task.v1.TaskAuditCreatedReplacementExtensionGrantTask", [
            { no: 1, name: "new_task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "new_task_numeric_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditCreatedReplacementExtensionGrantTask
 */
export const TaskAuditCreatedReplacementExtensionGrantTask = new TaskAuditCreatedReplacementExtensionGrantTask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditNewTaskCreatedFrom$Type extends MessageType<TaskAuditNewTaskCreatedFrom> {
    constructor() {
        super("c1.api.task.v1.TaskAuditNewTaskCreatedFrom", [
            { no: 1, name: "original_task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "original_task_numeric_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditNewTaskCreatedFrom
 */
export const TaskAuditNewTaskCreatedFrom = new TaskAuditNewTaskCreatedFrom$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditReassignmentFallbackToAdmin$Type extends MessageType<TaskAuditReassignmentFallbackToAdmin> {
    constructor() {
        super("c1.api.task.v1.TaskAuditReassignmentFallbackToAdmin", [
            { no: 1, name: "admin_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "admin_users", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => User }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditReassignmentFallbackToAdmin
 */
export const TaskAuditReassignmentFallbackToAdmin = new TaskAuditReassignmentFallbackToAdmin$Type();
/**
 * @generated ServiceType for protobuf service c1.api.task.v1.TaskAudit
 */
export const TaskAudit = new ServiceType("c1.api.task.v1.TaskAudit", [
    { name: "List", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/task/audits", group: "Task" }] } }, I: TaskAuditListRequest, O: TaskAuditListResponse }
]);
